export const DEVICE_TYPE_NAME = {
    COBAS_PULSE: 'cobas pulse',
    ACI_II: 'ACI II',
    COAGUCHEK_PRO_II: 'CoaguChek Pro II',
} as const;

export const DEVICE_TYPES_WITH_SETTINGS = new Set<string>(Object.values(DEVICE_TYPE_NAME));

export const MAX_NUMBER_OF_ITERATIONS = 10; // Levels of deepness to resolve dependencies

// values of DEVICE_TYPE_NAME

// values of device type name as a type
// export type DeviceTypeName = (typeof DEVICE_TYPE_NAME)[keyof typeof DEVICE_TYPE_NAME
// export type DeviceTypeName = typeof DEVICE_TYPE_NAME[keyof typeof DEVICE_TYPE_NAME];
// export type DeviceTypeName = keyof typeof DEVICE_TYPE_NAME;
